import { Link } from "@tanstack/react-router";
import { ArrowRight, MessageCircle, Phone } from "lucide-react";
import { contactInfo } from "../lib/data";

export function CtaBand() {
  const tekst = encodeURIComponent(
    "Hoi Fedor, ik wil graag een inschatting. Ik stuur een paar foto's mee.",
  );
  return (
    <section className="border-t border-border/60 bg-primary/10 py-14 sm:py-20 lg:py-28">
      <div className="container-tight text-center">
        <h2 className="font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
          Creëer je droomhuis.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-muted-foreground">
          Vertel ons vandaag nog over je project. Je krijgt eerlijk advies, een duidelijk plan en
          een transparante offerte.
        </p>
        <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <Link
            to="/contact"
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-md bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Gratis offerte aanvragen
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
          <a
            href={`${contactInfo.whatsappHref}?text=${tekst}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-md bg-foreground px-6 py-3 text-sm font-semibold text-background transition-colors hover:bg-foreground/85"
          >
            <MessageCircle className="h-4 w-4" aria-hidden="true" />
            WhatsApp ons
          </a>
          <a
            href={contactInfo.telefoonHref}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-md border border-input bg-background px-6 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-accent"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            {contactInfo.telefoon}
          </a>
        </div>
      </div>
    </section>
  );
}
